const rail = {
  rails: "Schienen", // translated
  senior: "Senior", // translated
  seniors: "Senioren", // translated
  youths: "Jugendliche", // translated
  yearOld: "Jahr alt", // translated
  yearsOld: "Jahre alt", // translated
};

export default rail;
